<template>
    <div>
        <hua-nav-bar
            :title="'邀约申请'"
            left-arrow
            @click-left="onClickLeft"
            style="margin-bottom: 10px"
        ></hua-nav-bar>
        <!-- 只展示邀约 -->
        <invite
            ref="inviteRef"
            v-show="active === 2 && inviteMode"
            :visitorMode="visitorMode"
            :v_personid="v_personid"
            :userId="userId"
            :u_name="u_name"
            :u_phone="u_phone"
        ></invite>
        <invite-origin
            ref="inviteRef"
            v-show="active === 2 && !inviteMode"
            :visitorMode="visitorMode"
            :v_personid="v_personid"
            :userId="userId"
            :u_name="u_name"
            :u_phone="u_phone"
        ></invite-origin>
    </div>
</template>

<script>
import invite from '@/view/myVisitorList/components/invite.vue'
import inviteOrigin from '@/view/myVisitorList/components/invite_origin.vue'
import api from '@/constants/api'
export default {
    components: {
        invite,
        inviteOrigin
    },
    data() {
        return {
            active: 0,
            u_phone: null,
            u_name: null,
            v_personid: null, //h5
            userId: null, // APP
            inviteMode:true,
            showAllTab:true,
            // 判断当前页面是不是直接从企业号(logEnterprise)或公众号(log)跳转过来的
            logJumpVisitorList:false,
            jobNum:null
        }
    },
    methods: {
        onClickLeft() {
            let logLastPageVisitor = localStorage.getItem('logLastPageVisitor')
            let lastPageVisitor = localStorage.getItem('lastPageVisitor')
            let accountCode = ''
            let accountState = ''
            if (localStorage.getItem("accountCode")) {
                accountCode = JSON.parse(localStorage.getItem("accountCode"))
                accountState = JSON.parse(localStorage.getItem("accountState"))
            }
            if (window.navigator.userAgent.indexOf('dhb') !== -1) {
                window.addEventListener('dhbready', async () => {
                    let plugin = await DhbPlugin('dhb/plugin/messagehandle')
                    if (plugin) {
                        plugin.callHandler('finish', 'para', (message) => {
                            console.log(1)
                        })
                    }
                })
            } else if (lastPageVisitor === 'log' || logLastPageVisitor === 'log') {
                this.$router.push({ path: `/log?code=${accountCode}&state=${accountState}` })
            } else if (lastPageVisitor === 'logEnterprise' || logLastPageVisitor === 'logEnterprise') {
                this.$router.push({ path: `/logEnterprise?personCode=${this.jobNum}` })
            } else {
                this.$router.push({ name: 'index' })
            }
            // localStorage.removeItem('v_personid')
        },
        visitConfig() {
            api.getVisitConfig(130).then((res) => {
                if (res.data[0].value == 0) {
                    this.inviteMode = false
                }else if(res.data[0].value == 1) {
                    this.inviteMode = true
                }
            })
        },
    },
    created() {
      this.visitorMode = localStorage.getItem('visitorMode') ? JSON.parse(localStorage.getItem('visitorMode')) : ''
      console.log('visitorMode123', this.visitorMode);
      // if(!this.visitorMode) {
      //   this.$toast('访问模式为空')
      // }
    },
    mounted() {
      this.logJumpVisitorList = JSON.parse(localStorage.getItem('logJumpVisitorList'))
      this.visitConfig()
      this.active = Number(localStorage.getItem('myVisitorListActive'));
      this.jobNum = sessionStorage.getItem('u_jobNumber');
      if(this.jobNum) {
        // this.jobNum = typeof this.jobNum === 'string' ? JSON.parse(this.jobNum) : this.jobNum
      }
    //   console.log(!localStorage.getItem('v_personid'),"v_personid=============审核======")
        if(!localStorage.getItem('v_personid')) {
           this.$router.push({name: 'index'});
           this.v_personid = localStorage.getItem('v_personid')
        } else {
            this.v_personid = JSON.parse(localStorage.getItem('v_personid')) //h5登录时存的
            this.v_personid = this.v_personid.toString();
        }
        this.userId = localStorage.getItem('userId') //APP登录时存的
        const fromH5 = localStorage.getItem('fromH5');
        if (!fromH5 && this.userId) {
          api.checkPersonIdByuserId(this.userId)
                .then((res) => {
                    this.u_phone = res.data.phone
                    this.u_name = res.data.name
                    this.v_personid = res.data.personId
                    localStorage.setItem('u_phone', JSON.stringify(this.u_phone))
                    sessionStorage.setItem('u_name', this.u_name)
                    localStorage.setItem('v_personid', JSON.stringify(this.v_personid))
                    if (this.$route.params.active) {
                        let active = this.$route.params.active
                        this.active = active === 'detail' ? 1 : active === 2 ? 2 : 0
                    }
                    if (this.active !== 2) {
                        this.$refs.wait && (this.$refs.wait.getReviewList(this.v_personid));
                    }
                    this.$router.push({
                        path: `/teacherInvita/${this.v_personid}`,
                    })
                })
                .catch((err) => {
                    localStorage.removeItem('u_phone')
                    sessionStorage.removeItem('u_name')
                    this.$toast(JSON.stringify(err.errMsg));
                })
        } else {
            if (this.$route.params.active) {
                let active = this.$route.params.active
                this.active = active === 'detail' ? 1 : active === 2 ? 2 : 0
            }
            if (this.active !== 2) {
                this.$refs.wait && this.$refs.wait.getReviewList(this.v_personid)
            }
            this.$router.push({
                path: `/teacherInvita/${this.v_personid}`,
            })
        }
    },
     // 判断当前页面是从哪个页面跳转过来的
    beforeRouteEnter (to, from, next) {
        localStorage.setItem('lastPageVisitor', from.name)
        if(from.name === 'log' || from.name === 'logEnterprise') {
            localStorage.setItem('logLastPageVisitor', from.name)
        }
        if(from.name === 'log' || from.name === 'logEnterprise' || from.name ==='approvaSingleLogin') { // 当前是从访客管理导航页面页面跳过来的(公众号(log)或企业号(logEnterprise))
            localStorage.setItem('logJumpVisitorList', JSON.stringify(true))
        }else {
            localStorage.setItem('logJumpVisitorList', JSON.stringify(false))
        }
        next()
    }
}
</script>
